// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as TicketStatus from "../../../../to-be-migrated/domain/types/order/tickets/TicketStatus.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as OrderTicketApiModel from "../api-model/OrderTicketApiModel.bs.js";

function decodeResolutionComments(comment) {
  return {
          latest_comment: comment.latest_comment,
          total_comments: comment.total_comments
        };
}

function execute(json) {
  var tickets = DeccoUtils$Catalyst.resolveResult(OrderTicketApiModel.t_decode(json), "OrderTicketEntityMapper.re");
  return List.map((function (t) {
                return {
                        case_id: t.case_id,
                        created_at: t.created_at,
                        raised_by: t.raised_by,
                        issues: t.issues,
                        issue_comment: t.issue_comment,
                        actions_taken: t.actions_taken,
                        action_comment: t.action_comment,
                        resolution_comments: decodeResolutionComments(t.resolution_comments),
                        status: TicketStatus.fromString(t.status)
                      };
              }), tickets);
}

export {
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
